import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="navbar-dark bg-dark">
      <div className="container pt-1">
        <footer className=" mt-4 py-1">
          <ul className="nav justify-content-center border-bottom  mb-3">
            <li className="nav-item">
              <Link to={`/about`} class="text-center text-muted">
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link to={`/faqs`} class="text-center text-muted">
                FAQs
              </Link>
            </li>
            <li className="nav-item">
              <Link to={`/contact`} class="text-center text-muted">
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link to={`/privacy-policy`} class="text-center text-muted">
                Privacy Policy
              </Link>
            </li>

            <li className="nav-item">
              <Link to={`/terms`} class="text-center text-muted">
                Terms & Conditions
              </Link>
            </li>
          </ul>
          <p class="text-center text-muted">© eksplode! code 2021, Inc</p>
        </footer>
      </div>
    </div>
  );
};

export default Footer;
